import { render, staticRenderFns } from "./H1Scores.vue?vue&type=template&id=3df5d5dc&scoped=true&"
import script from "./H1Scores.vue?vue&type=script&lang=js&"
export * from "./H1Scores.vue?vue&type=script&lang=js&"
import style0 from "./H1Scores.vue?vue&type=style&index=0&id=3df5d5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df5d5dc",
  null
  
)

/* custom blocks */
import block0 from "./H1Scores.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports